<div class="cg-flex cg-flex-vertical-center" [class.expanded-bg]="expanded">
  <section class="content-section">
    <div (click)="toggle()" class="clickable">
      <div data-test="latest-update-date">
        {{ update.date | date: 'M/d/yy' }}
      </div>
      <div>
        <strong data-test="latest-update-title">{{ update.title }}</strong>
      </div>
      <div
        *ngIf="expanded"
        class="cg-margin-top-sm latest-update-content"
        data-test="latest-update-content"
        [innerHTML]="update.content"
      ></div>
    </div>
    <div class="cg-margin-top-sm" *ngIf="update.path">
      <a
        [attr.target]="update.resourceLink ? 'resourcesWindow' : '_blank'"
        [attr.href]="
          update.resourceLink
            ? (update.path | resourceLink: { targetApp: 'both' } | async)
            : update.path
        "
        >{{ update.linkText
        }}<cigna-icon
          *ngIf="update.openExternal"
          type="external-link"
          class="cg-mat-icon-link-right cg-link-color"
        ></cigna-icon>
      </a>
    </div>
  </section>

  <div (click)="toggle()" class="clickable toggle-section">
    <cigna-icon
      *ngIf="!expanded"
      class="toggle-icon"
      type="chevron-down"
    ></cigna-icon>
    <cigna-icon
      *ngIf="expanded"
      class="toggle-icon"
      type="chevron-up"
    ></cigna-icon>
  </div>
</div>
